import { types as content } from "../actions/content";
import { types as sites } from "../actions/sites";
import { types as auth } from "../actions/auth";

const initialState = {};

const walkTree = (items, func, parentId = null) => {
  items.map((item, i) => {
    func(item, i, parentId);
    if (item.children && item.children.length) {
      walkTree(item.children, func, item.id);
    }
  });
};

const updateContent = (state, { type, content }) => {
  const arr = state[type.id] || [];
  const index = arr.findIndex(c => c.id === content.id);
  const nextArr =
    index > -1
      ? [...arr.slice(0, index), content, ...arr.slice(index + 1)]
      : [...arr, content];

  return { [type.id]: nextArr };
};

const removeContent = (state, { type, content }) => {
  const arr = state[type.id] || [];
  const index = arr.findIndex(c => c.id === content.id);

  return {
    [type.id]: [...arr.slice(0, index), ...arr.slice(index + 1)]
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case content.LOAD:
      return {
        ...state,
        [action.data.type.id]: action.data.content || []
      };

    case content.SAVE:
      return {
        ...state,
        ...updateContent(state, action.data)
      };

    case content.DELETE:
      return {
        ...state,
        ...removeContent(state, action.data)
      };

    case content.REORDER:
      const data = [];
      walkTree(action.data.content, (item, index, parentId) => {
        data.push({ id: item.id, parent_id: parentId });
        const model = state[action.data.typeId].find(v => v.id === item.id);
        model.position = index;
        model.parent_id = parentId;
      });
      return {
        ...state,
        [action.data.typeId]: state[action.data.typeId].map(content => {
          const found = data.find(i => i.id === content.id);
          return { ...content, ...found };
        })
      };

    case sites.CHANGE:
    case auth.FAIL:
    case auth.LOGOUT:
      return initialState;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/content.js